const OPTIONS_TYPE_COMPARUTION: Array<{
  key: number;
  text: string;
  value: number;
}> = [
  {
    key: 1,
    text: 'Comparution personnelle et simultanée des partenaires',
    value: 1,
  },
  {
    key: 2,
    text: 'Partenaire 1 durablement empêché',
    value: 2,
  },
  {
    key: 3,
    text: 'Partenaire 2 durablement empêché',
    value: 3,
  },
  {
    key: 4,
    text: 'Les 2 partenaires durablement empêchés',
    value: 4,
  },
];

export default OPTIONS_TYPE_COMPARUTION;
